"use strict";

exports.__esModule = true;
exports.default = void 0;

var _deconstructNumberFormat = _interopRequireDefault(require("deconstruct-number-format"));

var _formatNumberWithString = _interopRequireDefault(require("format-number-with-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

let defaults = {
  decimal: '.',
  grouping: ','
};

/**
 * A straightforward number formatting and parsing localizer that is locale
 * agnostic. Provide all the localization relevant options to configure to the desired culture.
 *
 * ```js
 * const SimpleNumberLocalizer = require('react-widgets-simple-number');
 *
 * <LocalizationProvider
 *   localizer={new SimpleNumberLocalizer({
 *     decimal: ',',
 *     grouping: '.'
 *   })}
 * />
 * ```
 */
class SimpleNumberLocalizer {
  /**
   *
   * @param {Object} options            A set of options used to configure localization details
   * @param {string} options.decimal    The decimal seperator character defaults to `.`
   * @param {string} options.grouping   The "thousands" seperator char character defaults to `,`
   */
  constructor(options = {}) {
    let {
      decimal,
      grouping
    } = Object.assign({}, defaults, options);

    this.decimalCharacter = () => decimal;

    this.format = (num, format) => {
      if (typeof format === 'function') {
        return format(num);
      }

      return (0, _formatNumberWithString.default)(num, format || `-#${grouping}##0${decimal}`);
    };
  }

  parse(value, format) {
    if (format) {
      let data = (0, _deconstructNumberFormat.default)(format),
          negative = data.negativeLeftSymbol && value.indexOf(data.negativeLeftSymbol) !== -1 || data.negativeRightSymbol && value.indexOf(data.negativeRightSymbol) !== -1;
      value = value.replace(data.negativeLeftSymbol, '').replace(data.negativeRightSymbol, '').replace(data.prefix, '').replace(data.suffix, '');
      let halves = value.split(data.decimalChar);
      if (data.integerSeperator) halves[0] = halves[0].replace(new RegExp('\\' + data.integerSeperator, 'g'), '');
      if (data.decimalsSeparator) halves[1] = halves[1].replace(new RegExp('\\' + data.decimalsSeparator, 'g'), '');
      if (halves[1] === '') halves.pop();
      value = halves.join('.');
      value = +value;
      if (negative) value = -1 * value;
    } else value = parseFloat(value);

    return isNaN(value) ? null : value;
  }

}

var _default = SimpleNumberLocalizer;
exports.default = _default;
